<script lang="ts" setup>
import { useValidationError } from "@vm/validation";

import InputNumber from "primevue/inputnumber";

const props = defineProps({
  helpText: {
    type: String,
    default: undefined,
    required: false,
  },
  label: {
    type: String,
    required: true,
  },
  fullPath: {
    type: String,
    default: undefined,
    required: false,
  },
  showButtons: {
    type: Boolean,
    default: false,
    required: false,
  },
  locale: {
    type: String,
    default: "nl-NL",
  },
});

const { validationError, resetValidation } = useValidationError(props.fullPath);
</script>

<template>
  <div class="w-full flex flex-col">
    <label class="text-xs text-gray-800" :for="fullPath">{{ label }}</label>
    <InputNumber
      v-bind="$attrs"
      :id="fullPath"
      size="small"
      class="w-full"
      :class="{ 'p-invalid': !!validationError }"
      :locale="locale"
      :show-buttons="showButtons"
      @keydown="() => resetValidation()"
    />
    <small v-if="helpText">{{ helpText }}</small>
    <small v-if="validationError?.message" class="text-wrap text-red-600">{{
      validationError?.message
    }}</small>
  </div>
</template>

<style lang="postcss" scoped>
:deep(.p-inputnumber-input) {
  @apply p-[10.5px] text-[14px];
}

:deep(.p-float-label) {
  @apply h-[44px];
}

.number-input-with-buttons {
  :deep(.p-inputnumber-input) {
    @apply rounded-r-none;
  }

  :deep(.p-inputnumber-button-down) {
    @apply rounded-l-none rounded-tr-none py-0;
  }

  :deep(.p-inputnumber-button-up) {
    @apply rounded-l-none rounded-br-none py-0;
  }
}
</style>
